import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import "../../App.css";
import HeaderBack from "../../components/Header/HeaderBack";
import DiceLoading from "../../components/DiceLoading";
import GetOneProfile from "../../components/GetProfile/GetOneProfile.js";
import GetOneProfileExtra from "../../components/GetProfile/GetOneProfileExtra.js";
import { getFamilyCon } from "../../handlers/dictionaryHandler.js";

const HelperHome = () => {
  let history = useHistory();

  const [helpersCandidates, setHelpersCandidates] = useState([]);
  const [helperFullName, setHelperFullName] = useState("");
  const [openProfileIds, setOpenProfileIds] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isErrorMessageDisplayed, setIsErrorMessageDisplayed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  const alertUser = (message) => {
    setIsErrorMessageDisplayed(true);
    setErrorMessage(message);
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_LOCALHOST_ADDRESS +
            "/PhelperHome?cellular=543030832",
          config,
        );

        setHelperFullName(response.data.helper?.helperFullName || "");
        setHelpersCandidates(response.data.candidates || []);
        setIsDataLoaded(true);
      } catch (error) {
        setIsDataLoaded(true);
        alertUser("יש שגיאה בשרת או שאבד החיבור לאינטרנט, אנא נסה/י שנית");
      }
    };

    loadData();
  }, []);

  return (
    <form className="supermatchmaker-form">
      {isDataLoaded === true ? (
        <>
          <HeaderBack />
          <br />
          <div className="signup-body">
            <br />
            <h5 className="vipDescription">
              {helperFullName !== ""
                ? `שלום ${helperFullName}, טוב שבאת :)`
                : "טוב שבאת :)"}
            </h5>
            <h5 className="vipDescription">אזור המלווים</h5>
            <div className="line"></div>

            <h5 className="h5middle">האנשים שנרשמו דרכך</h5>

            <div className="messegeMatch">
              כאן אפשר לראות את הקרובים שנרשמו דרכך, ולצפות בהתאמות שלהם רק אם
              אישרו לך גישה.
            </div>

            <br />

            {helpersCandidates.length > 0 ? (
              helpersCandidates.map((candidate, index) => (
                <div className="pause-card" key={index}>
                  <div className="pause-title">{candidate.fullName}</div>

                  <div className="messegeMatch">
                    קרבה: {getFamilyCon(candidate.connection)}
                  </div>

                  <div className="messegeMatch">
                    סטטוס:{" "}
                    {candidate.allowSee == 1
                      ? "אישר/ה גישה ✅"
                      : "ממתין/ה לאישור"}
                  </div>

                  {candidate.allowSee == 1 ? (
                    <>
                      <div className="faceline" style={{ gap: "12px" }}>
                        <div
                          className="action-btn helper-action-btn"
                          onClick={() => {
                            setOpenProfileIds((prev) =>
                              prev.includes(candidate.idCandidate)
                                ? prev.filter(
                                    (id) => id !== candidate.idCandidate,
                                  )
                                : [...prev, candidate.idCandidate],
                            );
                          }}
                        >
                          {openProfileIds.includes(candidate.idCandidate)
                            ? "סגירת פרופיל"
                            : "צפייה בפרופיל"}
                        </div>

                        <Link
                          to={{
                            pathname: "/helperMatches",
                            state: {
                              candidateId: candidate.idCandidate,
                              candidateName: candidate.fullName,
                            },
                          }}
                          className="action-btn helper-link-reset helper-action-btn"
                        >
                          צפייה בהתאמות
                        </Link>
                      </div>
                      <div
                        style={{
                          fontSize: "0.9rem",
                          color: "#777",
                          marginTop: "10px",
                          textAlign: "center",
                        }}
                      >
                        אפשר לראות את הפרופיל ולהציע שיפורים למועמד/ת
                      </div>
                      {openProfileIds.includes(candidate.idCandidate) && (
                        <div style={{ marginTop: "16px" }}>
                          <GetOneProfile otherId={candidate.idCandidate} />
                          <GetOneProfileExtra
                            otherId={candidate.idCandidate}
                            showManagerOnly={false}
                          />
                        </div>
                      )}
                    </>
                  ) : (
                    <div
                      style={{
                        fontSize: "0.9rem",
                        color: "#777",
                        marginTop: "8px",
                      }}
                    >
                      עדיין אין גישה לצפייה בהתאמות של {candidate.fullName}
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="pause-card">
                <div className="pause-title">עדיין אין כאן מועמדים</div>
                <div className="messegeMatch">
                  כאשר קרובים יירשמו דרכך, הם יופיעו כאן.
                </div>
              </div>
            )}

            {isErrorMessageDisplayed && (
              <div className="error-message">
                <h5>{errorMessage}</h5>
              </div>
            )}

            <br />

            <Link to="/questionnaires" style={{ textDecoration: "none" }}>
              <div className="button whiteBackNBorder" id="backBtn">
                <b>→</b>
                חזרה
              </div>
            </Link>

            <br />
          </div>
        </>
      ) : (
        <DiceLoading />
      )}
    </form>
  );
};

export default HelperHome;
